export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.14-1505.52",
  commitId: "0c4195cfc1fe62c3f50ce0ae54ee6c6f7abea79a",
  commitTime: "2026-09-14T15:05:52.000Z",
});
